import { render, staticRenderFns } from "./TmBtn.vue?vue&type=template&id=43fe3e16&scoped=true&"
import script from "./TmBtn.vue?vue&type=script&lang=js&"
export * from "./TmBtn.vue?vue&type=script&lang=js&"
import style0 from "./TmBtn.vue?vue&type=style&index=0&id=43fe3e16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fe3e16",
  null
  
)

export default component.exports